import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { Observable } from "rxjs";
import { NgStyle, NgClass, AsyncPipe } from "@angular/common";

import { StepService } from "@shared/components/steps/services/step/step.service";

import { StatusByStepPipe } from "./pipes/status-by-step/status-by-step.pipe";

@Component({
  selector: "app-steps",
  templateUrl: "./steps.component.html",
  styleUrls: ["./steps.component.scss"],
  imports: [NgStyle, NgClass, AsyncPipe, StatusByStepPipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class StepsComponent {
  private stepService = inject(StepService);

  steps = ["Cadastro", "Pagamento", "Conclusão"];

  step$: Observable<number>;

  constructor() {
    const stepService = this.stepService;

    this.step$ = stepService.getStep();
  }
}
